module.exports = __webpack_public_path__ + "static/media/email.cfb23281.png";